export const formatNum = (num, round = 2) => {
  if (!num) return 0

  return Number(Number(num).toFixed(round)).toLocaleString()
}

export const formatPrice = (number) => {
  return Math.round(number * 100) / 100
}
